"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Line = exports.PlaceholderLine = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var PlaceholderLine = function (props) {
    var long = props.long, medium = props.medium, short = props.short, thin = props.thin, thick = props.thick;
    var classes = { medium: medium, long: long, thin: thin, thick: thick, short: short };
    return react_1.default.createElement(exports.Line, { className: (0, classnames_1.default)('line', classes) });
};
exports.PlaceholderLine = PlaceholderLine;
exports.Line = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 14px;\n  display: block;\n\n  &.long {\n    width: 85%;\n  }\n\n  &.medium {\n    width: 50%;\n  }\n\n  &.short {\n    width: 35%;\n  }\n\n  &.thin {\n    height: 8px;\n  }\n\n  &.thick {\n    height: 30px;\n  }\n"], ["\n  width: 100%;\n  height: 14px;\n  display: block;\n\n  &.long {\n    width: 85%;\n  }\n\n  &.medium {\n    width: 50%;\n  }\n\n  &.short {\n    width: 35%;\n  }\n\n  &.thin {\n    height: 8px;\n  }\n\n  &.thick {\n    height: 30px;\n  }\n"])));
exports.default = exports.PlaceholderLine;
var templateObject_1;
